import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { RouteType } from "src/enums";
import { RouteService, _ } from "src/services";
import { Modals, ModalsAction, UserSessionAction } from "src/store";
import { Modal } from "./modal";

export const LogoutModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const history = useHistory();
    const modals: Modals = useSelector((state: any) => state.ModalsState);

    //#endregion

    //region methods

    const onClose = () => {
        dispatch(ModalsAction.hideLogout());

    };

    const onLogout = () => {
        dispatch(UserSessionAction.logout());
        onClose();

        const route = RouteService.getCurrentRoute();
        if (route && route.routeType === RouteType.Authenticated) {
            history.push("/");
        }
    };

    //#endregion

    //#region helpers

    const renderFooter = () => {
        return (
            <>
                <div className="col-5">
                    <button onClick={onLogout} className="w-100 btn focusable btn-submit">{_("logout")}</button>
                </div>
                <div className="col-5 offset-2">
                    <button onClick={onClose} className="w-100 btn btn-cancel">{_("cancel")}</button>
                </div>
            </>
        );
    };


    const renderBody = () => {
        return (
            <div className="content text-center">
                <p className="rtl">{_("logoutMessage")}</p>
            </div>
        );
    };

    //#endregion

    return (
        <Modal title={_("logoutTitle")} show={modals.logout} onClose={onClose} renderFooter={renderFooter} className="modal-component--logout">
            <div className="content text-center">
                {renderBody()}
            </div>
        </Modal>
    );

};